<rt-dropdown *ngIf="!selectedCategory" class="dropdown">
  <rt-dropdown-header [fullWidthTitle]="true"> {{ header }} </rt-dropdown-header>
  <rt-dropdown-item
    *ngFor="let category of categories; trackBy: trackByCategoryName"
    (mousedown)="setCategory(category, $event)"
    [hasChevronRight]="true"
  >
    <div layout-vertical>
      <rt-heading variant="heading">
        {{ placeholderCategoryTranslationMap[category].name }}
      </rt-heading>
      <span
        [innerHTML]="placeholderCategoryTranslationMap[category].desc"
        class="description info-dropdown-text"
      ></span>
    </div>
  </rt-dropdown-item>
  <rt-dropdown-item
    *ngFor="let placeholder of noCategoryPlaceholders; trackBy: trackByPlaceholderName"
    [insertPlaceholder]="placeholder.id"
    [insertPlaceholderTarget]="activeTarget!"
    [isSelected]="placeholder.id === active?.id"
    (click)="select.emit(placeholder)"
    layout-vertical
  >
    <div layout layout-horizontal layout-space-between>
      <div layout layout-vertical>
        <rt-heading variant="heading">
          <span class="preserve-whitespace" margin-right-small-xx text-primary>[ </span>
          {{ withoutBrackets(placeholder.id) }}
          <span class="preserve-whitespace" margin-left-small-xx text-primary> ]</span>
        </rt-heading>
        <span
          [innerHTML]="placeholder.interpolated ? placeholder.value : placeholder.data.description"
          class="description"
        >
        </span>
      </div>
    </div>
  </rt-dropdown-item>
  <ng-template [ngIf]="selectFooterTemplate" [ngTemplateOutlet]="selectFooterTemplate">
  </ng-template>
</rt-dropdown>
<rt-placeholder-select-dropdown
  *ngIf="selectedCategory"
  [placeholders]="placeholders"
  [category]="selectedCategory"
  [activeTarget]="activeTarget!"
  [active]="active"
  [showHeader]="true"
  (back)="setCategory()"
  (select)="setCategory(); select.emit($event)"
></rt-placeholder-select-dropdown>
